import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TableauDashboardComponent } from '@base/tableau-dashboard/tableau-dashboard.component';
import { TableauWorkbookComponent } from '@base/tableau-dashboard/tableau-workbooks/tableau-workbooks.component';
import { TableauWorkbookViewComponent } from '@base/tableau-dashboard/tableau-workbook-view/tableau-workbook-view.component';
import { TableauImageComponent } from '@base/tableau-dashboard/tableau-image/tableau-image.component';
import { TableauViewsComponent } from '@base/tableau-dashboard/tableau-views/tableau-views.component';

export const tableauRoutes: Routes = [
  {
    path: 'panels',
    component: TableauDashboardComponent,
    children: [
      {
        path: 'tableau',
        component: TableauWorkbookComponent,
      },
      {
        path: 'tableau/:id/views',
        component: TableauViewsComponent,
      },
      {
        path: 'tableau/:id/views/:viewName',
        component: TableauWorkbookViewComponent
      },
      {
        path: 'tableau/:id/image',
        component: TableauImageComponent
      },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(tableauRoutes)
  ],
  exports: [RouterModule]
})
export class TableauDashboardRoutingModule { }
